import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import map from 'lodash/map'

import { getWeeks, publish } from "../../../actions/app/mpt/weeks";
import CreateWeek from './createWeek';
import Week from "./Week";

import './Creation.css'
import {denormalize} from "normalizr";
import { weekListSchema } from "../../../schemas/week";
import swal from "sweetalert2";

class MptClubs extends React.Component {
    componentWillMount() {
        const { dispatch } = this.props;
        dispatch(getWeeks())
    }

    publish() {
        const { dispatch } = this.props;
        swal({
            title: 'Are you sure ?',
            type: 'info',
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText:
                'Yes',
            cancelButtonText:
                'No',
        }).then(() => {
            dispatch(publish());
        }).catch(error => {
            console.log(error);
        })
    }

    render() {
        const { weeks } = this.props;
        return (
            <div id="Creation">
                <header className="content-header">
                    <h1>
                        Dashboard
                        <small>Clubs</small>
                    </h1>
                    <ol className="breadcrumb">
                        {/*<li><i className="fa fa-trophy"/> MPP</li>*/}
                        <li className="text-bold"><Link to="/mpt">Dashboard</Link></li>
                    </ol>
                </header>
                <section className="content">
                    <div className="row">
                        <div id="players-list-widget" className="row">
                            <div className="col-md-12">
                                <div className="box box-default">
                                    <div className="box-header with-border">
                                        <div className="text-center">
                                            <button
                                                className="btn-danger"
                                                onClick={() => this.publish()}
                                            >
                                                PUBLISH
                                            </button>
                                        </div>
                                        <CreateWeek />
                                        <div className="row">
                                            {
                                                weeks && map(weeks, week => {
                                                    return (
                                                        <Week key={week.id} data={week} />
                                                    );
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

export default connect(
    state => ({
        weeks: denormalize(state.app.mpt.weeks.ids, weekListSchema, state.entities),
    }),
    dispatch => ({ dispatch }),
)(MptClubs);



// WEBPACK FOOTER //
// ./src/pages/MPT/Creation/index.js